import { render } from "./FooterIndex.vue?vue&type=template&id=402d7f77&scoped=true"
import script from "./FooterIndex.vue?vue&type=script&lang=js"
export * from "./FooterIndex.vue?vue&type=script&lang=js"

import "./FooterIndex.vue?vue&type=style&index=0&id=402d7f77&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402d7f77"]])

export default __exports__